import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articleList } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-lg font-heading font-bold tracking-tight">
              Panda<span className="text-primary-400">Buy</span>.asia
            </Link>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              The largest Pandabuy Spreadsheet directory. Discover verified fashion finds, shoes, clothing and accessories.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/article/shopping-guide" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  Shopping Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  Pandabuy Sheet
                </a>
              </li>
              <li>
                <a href="#categories" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  Categories
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Top Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">SEO Guides</h4>
            <ul className="space-y-2.5">
              {articleList.slice(0, 5).map((article) => (
                <li key={article.slug}>
                  <Link
                    to={`/article/${article.slug}`}
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                  >
                    {article.title.length > 40 ? article.title.substring(0, 40) + '...' : article.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/#articles" className="text-sm text-primary-400 hover:text-primary-300 transition-colors">
                  View All Guides →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 Pandabuy.asia. All rights reserved. Not affiliated with Pandabuy.
          </p>
          <div className="flex items-center gap-4">
            <a href="/" className="text-xs text-background-50/40 hover:text-background-50/80 transition-colors">
              Privacy Policy
            </a>
            <a href="/" className="text-xs text-background-50/40 hover:text-background-50/80 transition-colors">
              Disclaimer
            </a>
            <a href="/" className="text-xs text-background-50/40 hover:text-background-50/80 transition-colors">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}